// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCipX-sMf8imEGCOPwsUxT3rJrOIq2nziA',
  authDomain: 'diestrocode-project.firebaseapp.com',
  projectId: 'diestrocode-project',
  storageBucket: 'diestrocode-project.appspot.com',
  messagingSenderId: '547936093408',
  appId: '1:547936093408:web:78619d70491348900bbc85',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize firestore
export const authentication = getAuth(app);
export const db = getFirestore(app);
